// extracted by mini-css-extract-plugin
export var dropdownIcon = "_qh-6";
export var imgContainer = "_qh-3";
export var menuIcon = "_qh-5";
export var pillWrapper = "_qh-2";
export var pillsContainer = "_qh-1";
export var subscriptionCard = "_qh-0";
export var subscriptionLogo = "_qh-4";